import { render, staticRenderFns } from "./FinishedProject.vue?vue&type=template&id=205ff541&scoped=true&"
import script from "./FinishedProject.vue?vue&type=script&lang=js&"
export * from "./FinishedProject.vue?vue&type=script&lang=js&"
import style0 from "./FinishedProject.vue?vue&type=style&index=0&id=205ff541&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205ff541",
  null
  
)

export default component.exports